import React from 'react';

const ArrowLeft = ({ className }) => (
  <svg
    className={className}
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.07508 11.5714L-0.000107765 6.49624V5.07519L5.07508 -9.53674e-07L6.51643 1.42105L3.18711 4.77067L14.4946 4.77067V6.80075L3.18711 6.80075L6.53673 10.1504L5.07508 11.5714Z"
      fill="#E8B12C"
    />
  </svg>
);

export default ArrowLeft;
